import { Component, inject } from '@angular/core';
import { TuiPopover } from '@taiga-ui/cdk';
import { TuiDialogCloseService } from '@taiga-ui/core';
import { POLYMORPHEUS_CONTEXT } from '@taiga-ui/polymorpheus';

import { SidePageOptions } from './sidepage-options';

@Component({
  selector: 'app-sidepage',
  templateUrl: './sidepage.template.html',
  styleUrls: ['./sidepage.style.less'],
  host: {
    '[style.justify-content]': "context['justify-content']",
  },
  providers: [TuiDialogCloseService],
  standalone: false,
})
export class SidePageComponent {
  protected readonly context = inject<TuiPopover<SidePageOptions, boolean>>(POLYMORPHEUS_CONTEXT);
}
